// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__y0Dd3","container":"styles_container__2vqgN","title":"styles_title__d5AUK","wrapper":"styles_wrapper__awe7B","answer":"styles_answer__25uPO"};